import React from 'react';

import Caption from '../../../dumb/Caption/C';

import InvoicesTable from './InvoicesTable';
import Statistic from './Statistic';
import ReportDownload from "../../../dumb/ReportDownload/B";

module.exports = () => {
  return (
    <div className="w">
      <Caption>Dashboard</Caption>
      <Statistic />
      <div className="mt22">
        <InvoicesTable />
      </div>
    </div>
  );
};
